import React, { FC } from 'react'
import { CircularProgress } from '@mui/material'
import Box from '@mui/material/Box'

interface MainRoutesLazyFallbackProps {
	fallbackSx?: object
	loaderSlot?: React.ReactNode
}

const MainRoutesLazyFallback: FC<MainRoutesLazyFallbackProps> = ({
	fallbackSx,
	loaderSlot,
}: MainRoutesLazyFallbackProps) => {
	return (
		<Box
			sx={{
				height: '100vh',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				...fallbackSx,
			}}
		>
			{loaderSlot || <CircularProgress />}
		</Box>
	)
}

export default MainRoutesLazyFallback
